import { c as create_ssr_component, v as validate_component } from "../../../../chunks/ssr.js";
import { S as ServicePageTemplate } from "../../../../chunks/ServicePageTemplate.js";
import { C as CopyCard } from "../../../../chunks/CopyCard.js";
const _page_svelte_svelte_type_style_lang = "";
const css = {
  code: ".sections_wrapper.svelte-kjqbcq{padding:3rem 0;display:flex;flex-direction:column;align-items:center;gap:10rem;overflow:hidden}@media(max-width: 800px){.sections_wrapper.svelte-kjqbcq{padding:25px 5px}}.bottom.svelte-kjqbcq{padding-bottom:0}",
  map: null
};
let hero_image = "/taxi.webp";
let background_center = false;
let h1 = "Accelerated Pilot Program";
let hero_paragraph_content = "At First Landings Aviation, we offer Accelerated CFI training, Accelerated Instrument training, Accelerated PPL training as well as Accelerated Commercial flight training programs which cater to students aiming to complete their certificates in a shorter period of time by training more frequently.";
let pricingPackage = false;
let professionalProgram = false;
let programs = false;
let rentalRates = false;
let center_img_seperating_section = false;
let second_center_img_seperating_section = false;
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  $$result.css.add(css);
  return `${$$result.head += `<!-- HEAD_svelte-1sushj1_START -->${$$result.title = `<title>Accelerated Training | First Landings Aviation</title>`, ""}<meta name="description" content="First Landings Aviation accelerated pilot training"><!-- HEAD_svelte-1sushj1_END -->`, ""}  ${validate_component(ServicePageTemplate, "ServicePageTemplate").$$render(
    $$result,
    {
      hero_image,
      background_center,
      h1,
      hero_paragraph_content,
      pricingPackage,
      professionalProgram,
      programs,
      rentalRates,
      center_img_seperating_section,
      second_center_img_seperating_section
    },
    {},
    {
      three: () => {
        return `<div slot="three"><div class="sections_wrapper bottom svelte-kjqbcq"><div id="instrument">${validate_component(CopyCard, "CopyCard").$$render(
          $$result,
          {
            src: "/accelerated_instrument.webp",
            alt: "Accelerated instrument pilot training"
          },
          {},
          {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-5eslo5">Our Accelerated IFR training program is an intensive 7-day course
            that when you’re finished, you’ll have gained solid experience in
            the real world of IFR. This course is intended for those serious
            about adding an instrument rating to their private license, and want
            to get it done fast and efficiently. This course assumes the student
            has a Private Pilot License and 50 hours of PIC cross country time,
            including at least 25 hours of simulated or actual instrument time.
            If more time is needed, the student will pay for the normal rental
            of the aircraft beyond the 15 hours.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-1hoj47b">Instrument Rating</div>`;
            }
          }
        )}</div> <div id="career">${validate_component(CopyCard, "CopyCard").$$render(
          $$result,
          {
            src: "/accelerated_career.webp",
            alt: "Accelerated career pilot training",
            blueBorder: true
          },
          {},
          {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-v7mr6m">The Accelerated Career Pilot Program is a full-time path to your
            pilot career. Once enrolled, you will experience an intense training
            curriculum that requires daily attendance. Your days will be filled
            with classroom-based academic ground school and flight instruction
            in our aircraft. Graduates of the Core Module will obtain all
            certificates and ratings required to become a fully qualified
            Commercial Pilot. The Instructor Module enables students to earn
            their flight instructor ratings, allowing them to increase their
            experience through flight instruction.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-bflhjn">Career Pilot</div>`;
            }
          }
        )}</div></div></div>`;
      },
      two: () => {
        return `<div slot="two"><div id="private">${validate_component(CopyCard, "CopyCard").$$render(
          $$result,
          {
            src: "/accelerated_private.webp",
            alt: "Accelerated private pilot training",
            blueBorder: true
          },
          {},
          {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-1xe4f5w">Our Private Pilot Accelerated Program is an intensive 3-week course
          that gets you prepared to become a safe and competent pilot through
          our advanced training techniques to help you achieve your FAA Private
          Pilot certification. Our facilities include a luxurious pilot’s lounge
          and area for students to study and work with each other while here,
          and get you read to pass the practical test.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-1fxecri">Private Pilot</div>`;
            }
          }
        )}</div></div>`;
      },
      one: () => {
        return `<div slot="one"><div id="sport">${validate_component(CopyCard, "CopyCard").$$render(
          $$result,
          {
            src: "/accelerated_sport.webp",
            alt: "Accelerated sport pilot training"
          },
          {},
          {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-13t6fgc">Our Sport Pilot Accelerated Program is an intensive 2-week course that
          gets you prepared for your FAA Sport Pilot certification. We aim to
          help you become a safe and competent pilot through our advanced
          training techniques, ready to pass the FAA practical test. Our
          facilities include a luxurious pilot’s lounge and area for students to
          study and work with each other while here.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-1tiz69">Sport Pilot</div>`;
            }
          }
        )}</div></div>`;
      }
    }
  )}`;
});
export {
  Page as default
};
